import type {ReactElement} from 'react';
import React from 'react';
import type {ColorFillStorage} from '@Components/contextual-menu/components/contextual-menu-color-fill-option';
import {ContextualMenuColorFillOption} from '@Components/contextual-menu/components/contextual-menu-color-fill-option';
import {ColorFillPropertyType} from '@Components/color-fill';
import {getColorObjectArrayFromFillColor} from '@Utils/color.util';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromQRItem} from '@Hooks/poster-editor/useGetKeyFromQRItem';

interface QRContentColorFillProps {
  onClickColorFill(): void;
}

export function QRContentColorFill({onClickColorFill = (): void => {}}: QRContentColorFillProps): ReactElement<any> | null {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const itemQrForegroundColor = useGetKeyFromQRItem('qrForegroundColor');

  if (!activeItem || (activeItem && !('qrForegroundColor' in activeItem)) || !itemQrForegroundColor) {
    throw new Error(`QR Item doesn't have qrForegroundColor property`);
  }

  const getQRColorFill = (): ColorFillStorage[] => {
    return [
      {
        id: 'color-fill-qr',
        fillType: ColorFillPropertyType.SOLID,
        color: getColorObjectArrayFromFillColor([itemQrForegroundColor]),
      },
    ];
  };

  return (
    <ContextualMenuColorFillOption
      id="qr-color-fill-option"
      label={window.i18next.t('pmwjs_color')}
      data={getQRColorFill()}
      onClick={(): void => {
        onClickColorFill();
      }}
    />
  );
}
